// Label metode bayar untuk tampilan & rekap: non-tunai menyebut nama metodenya (mis. "noncash (BCA)"), pembayaran bagi
// menyebut "split". Data: transaksis.pembayaran, nonCashMethodName, bagiBayar, dan pembayaranBagi (rincian dari server).
export const labelPembayaran = (trx) => {
  if (!trx) return '-';
  const dasar = trx.pembayaran || trx.payment_method || '-';
  if (trx.bagiBayar) {
    const bagian = Array.isArray(trx.pembayaranBagi) ? trx.pembayaranBagi : [];
    const nama = bagian.map((b) => (b.metode === 'cash' ? 'tunai' : b.nonCashMethodName || 'non-tunai'));
    const awal = trx.adaPiutang ? 'uang muka' : 'split';
    return nama.length ? `${awal} (${nama.join(' + ')})` : awal;
  }
  if (dasar === 'noncash' && trx.nonCashMethodName) return `noncash (${trx.nonCashMethodName})`;
  return dasar;
};
